import { render, staticRenderFns } from "./GasRatioC2h2C2h4C2h4C2h6.vue?vue&type=template&id=dcbaee24&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports